import { Button } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { resetTicketsStore } from 'store/ticket-service/ticketSlice';
import { resetTicketShareStore } from 'store/ticket-share-service/ticketShareSlice';
import { getStripeInstance } from 'store/user-service/selector';
import { logout, setStripeInstance } from 'store/user-service/userSlice';

import { ROUTES } from 'core/constants/routes';
import { NamespacesList } from 'core/enums/common';
import usePaymentStream from 'core/hooks/usePaymentStream';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

type LogoutModalProps = {
	handleCloseModal: () => void;
};

export const LogoutModal: FC<LogoutModalProps> = ({ handleCloseModal }) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const stripeInstance = useSelector(getStripeInstance);

	const { closeConnection } = usePaymentStream();

	const navigate = useNavigate();
	const [open, setOpen] = useState<boolean>(true);
	const dispatch = useDispatch();

	const handleCloseConnection = () => {
		if (stripeInstance) {
			closeConnection(stripeInstance?.connection);
			dispatch(setStripeInstance(null));
		}
	};

	const handleClose = () => {
		handleCloseModal();
		setOpen(false);
	};

	const handleLogout = () => {
		dispatch(logout());
		dispatch(resetTicketsStore());
		dispatch(resetTicketShareStore());
		Object.keys(localStorage).forEach((key) => {
			if (key !== 'i18nextLng' && key !== 'paymentModalOpenings') {
				localStorage.removeItem(key);
			}
		});
		handleCloseConnection();
		navigate(ROUTES.LOGIN);
	};

	return (
		<InfoModal
			isOpen={open}
			onClose={handleClose}
			image={<Error />}
			title={modalTranslate('logoutModal.title')}
			description={modalTranslate('logoutModal.description')}
			buttons={
				<>
					<Button
						data-testid="logout-button"
						sx={{
							height: '44px',
							width: { xs: '49%', sm: '215px' },
							borderRadius: '8px',
							textTransform: 'none',
							fontSize: '16px',
							fontWeight: '700',
							marginTop: '24px',
						}}
						variant="outlined"
						color="error"
						onClick={handleLogout}
					>
						{modalTranslate('logoutModal.confirm')}
					</Button>

					<Button
						sx={{
							height: '44px',
							width: { xs: '49%', sm: '215px' },
							borderRadius: '8px',
							textTransform: 'none',
							fontSize: '16px',
							fontWeight: '700',
							marginTop: '24px',
						}}
						variant="contained"
						color="error"
						onClick={handleCloseModal}
					>
						{modalTranslate('logoutModal.cancel')}
					</Button>
				</>
			}
		></InfoModal>
	);
};
